import * as actions from './../actions/actionConstants.js';

const initialState = {
  divisionsList: [],
  parentDivisionsList: [],
  divisions: {},
  fetchingDivisionsStatus: '',
  seasonDivisionsList: [],
  seasonDivisions: {},
  fetchingSeasonDivisionsStatus: ''
};

const divisionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_DIVISIONS:
      return {
        ...state,
        fetchingDivisionsStatus: 'Loading'
      };
    case actions.GET_DIVISIONS_SUCCESS:
      return {
        ...state,
        divisionsList: [...action.divisionsList],
        parentDivisionsList: [...action.parentDivisionsList],
        divisions: { ...action.divisions },
        fetchingDivisionsStatus: 'Loaded'
      };
    case actions.GET_DIVISIONS_ERROR:
      return {
        ...state,
        fetchingDivisionsStatus: 'Error'
      };
      case actions.GET_SEASON_DIVISIONS:
        return {
          ...state,
          fetchingSeasonDivisionsStatus: 'Loading'
        };
      case actions.GET_SEASON_DIVISIONS_SUCCESS:
          return {
          ...state,
          seasonDivisionsList: [...action.divisionsList],
          seasonDivisions: { ...action.divisions },
          fetchingSeasonDivisionsStatus: 'Loaded'
        };
      case actions.GET_SEASON_DIVISIONS_ERROR:
        return {
          ...state,
          fetchingSeasonDivisionsStatus: 'Error'
        };
    case actions.USER_LOGOUT:
      return {
        divisionsList: [],
        parentDivisionsList: [],
        divisions: {},
        fetchingDivisionsStatus: '',
        seasonDivisionList: [],
        seasonDivisions: {},
        fetchingSeasonDivisionsStatus: '',
      };
    default:
      return state;
  }
};

export default divisionsReducer;



// WEBPACK FOOTER //
// ./src/reducers/divisions.js